import { render, staticRenderFns } from "./ReplyItem.vue?vue&type=template&id=6e15bd3a&scoped=true&"
import script from "./ReplyItem.vue?vue&type=script&lang=js&"
export * from "./ReplyItem.vue?vue&type=script&lang=js&"
import style0 from "./ReplyItem.vue?vue&type=style&index=0&id=6e15bd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15bd3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
